import { render, staticRenderFns } from "./cadnotasfiscais.vue?vue&type=template&id=1b296637&"
import script from "./cadnotasfiscais.vue?vue&type=script&lang=js&"
export * from "./cadnotasfiscais.vue?vue&type=script&lang=js&"
import style0 from "./cadnotasfiscais.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports